import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-10 text-center" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = {
  key: 4,
  class: "text-tile-border my-2"
}
const _hoisted_4 = {
  key: 6,
  class: "mb-auto"
}

import {Design} from "../../../../DesignSystem/design";
import Icon from "../../../../Icon/Icon.vue";
import {IconName} from "../../../../Icon/icons";
import {useNavigationStore} from "../../navigationStore";
import MessageCount from "../MessageCount.vue";
import UserAvatar from "../UserAvatar.vue";

interface Props {
  type: 'link'|'buttonPrimary'|'buttonSecondary'|'username'|'separatorDesktop'|'separatorMobile'|'spaceMobile';
  title?: string;
  icon?: IconName;
  messagesCount?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileMenuListItem',
  props: {
    type: {},
    title: {},
    icon: {},
    messagesCount: {}
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const store = useNavigationStore();
const props = __props;
const emit = __emit;

function click(): void {
  emit('click');
}

return (_ctx: any,_cache: any) => {
  return (props.type === 'link')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "py-3 text-xl active:text-green2-500 flex justify-between",
        onClick: click
      }, [
        _createTextVNode(_toDisplayString(props.title) + " ", 1 /* TEXT */),
        _createElementVNode("div", _hoisted_1, [
          (props.messagesCount)
            ? (_openBlock(), _createBlock(MessageCount, {
                key: 0,
                "messages-count": props.messagesCount
              }, null, 8 /* PROPS */, ["messages-count"]))
            : (props.icon)
              ? (_openBlock(), _createBlock(Icon, {
                  key: 1,
                  name: props.icon,
                  monospace: ""
                }, null, 8 /* PROPS */, ["name"]))
              : _createCommentVNode("v-if", true)
        ])
      ]))
    : (props.type === 'username')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "flex justify-between items-center py-3",
          onClick: click
        }, [
          _createElementVNode("div", {
            class: "text-xl text-neutral2-700 font-semibold",
            textContent: _toDisplayString(props.title)
          }, null, 8 /* PROPS */, _hoisted_2),
          _createVNode(UserAvatar, {
            user: _unref(store).$state.navigationUser
          }, null, 8 /* PROPS */, ["user"])
        ]))
      : (props.type === 'buttonPrimary')
        ? (_openBlock(), _createBlock(_unref(Design).Button, {
            key: 2,
            primary: "",
            class: "my-1.5 w-full",
            title: props.title,
            onClick: click
          }, null, 8 /* PROPS */, ["title"]))
        : (props.type === 'buttonSecondary')
          ? (_openBlock(), _createBlock(_unref(Design).Button, {
              key: 3,
              "primary-outline": "",
              class: "my-1.5 w-full",
              title: props.title,
              onClick: click
            }, null, 8 /* PROPS */, ["title"]))
          : (props.type === 'separatorMobile')
            ? (_openBlock(), _createElementBlock("hr", _hoisted_3))
            : (props.type === 'separatorDesktop')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [], 64 /* STABLE_FRAGMENT */))
              : (props.type === 'spaceMobile')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : _createCommentVNode("v-if", true)
}
}

})